// import React, { useEffect, useState } from "react";
// import TextStyles from "../../../../../components/Elements/TextStyles/TextStyles";
// import { ReactComponent as Back } from "../../../../../assets/svgs/back-button.svg";
// import OrganizationDeatils from "./OrganizationDetails/OrganizationDetails";
// import ContactDeatils from "./ContactDetails/ContactDetails";
// import MyProfile from "./MyProfile/MyProfile";
// import { useSelector } from "react-redux";
// import { getApi } from "../../../../../api/api_instance";
// import { API_URLS } from "../../../../../api/apiUrls";
// import LicenseAccess from "./LicenseAccess/LicenseAccess";
// import { THEME_COLORS } from "../../../../../color";
// import { IoArrowBackCircleOutline } from "react-icons/io5";
// import LicenceDetailPage from "./LicenseDetailPage/LicenceDetailPage";
// import PermissionForm from "../../../../Auth/PermissionForm";
// const Profile = () => {
//   const [openMyProfile, setOpenMyProfile] = useState(true);
//   const [openOrganizationDetails, setOpenOrgaizationDetails] = useState(false);
//   const [openContactdetails, setOpenContactDetails] = useState(false);
//   const [openLicenseDetails, setopenLicenseDetails] = useState(false);
//   const [showPermission, setPermission] = useState(false);
//   const { user } = useSelector((state) => state.auth);
//   const isPermissionCompleted = user?.isCompleted;

//   console.log(isPermissionCompleted, "PermissionFormPermissionForm");

//   // Automatically show permission form when component mounts if not completed
//   useEffect(() => {
//     if (!isPermissionCompleted) {
//       setPermission(true);
//     }
//   }, [isPermissionCompleted]);
//   return (
//     <div className="md:p-6 lg:p-0 bg-[#F5F5F5] mb-20 sm:mb-6 md:mb-6">
//       {!isPermissionCompleted && showPermission && (
//         <PermissionForm
//           permissionConClose={() => setPermission(false)}
//           //  permissionConClose={handlePermissionClose}
//           // isClosable={isPermissionCompleted} // Pass prop to control close button visibility
//         />
//       )}

//       <div
//         className={` ${
//           !isPermissionCompleted ? "blur-sm opacity-20 pointer-events-none" : ""
//         }`}
//       >
//         <div className="flex flex-wrap justify-end text-xs font-light gap-1 h-5 sm:gap-2">
//           <p>Home</p>
//           <span>/</span>

//           <TextStyles style={{ color: "#06513D" }}>Profile</TextStyles>
//         </div>

//         {/* Title & Back Icon */}
//         <div className="flex items-center gap-2 mb-3 sm:mb-1.5 text-lg sm:text-xl font-bold flex-wrap">
//           {/* <IoArrowBackCircleOutline className="w-8 sm:w-10 h-8 sm:h-10 text-[#06513D] hover:text-white hover:bg-[#06513D] rounded-full transition" />

//           */}
//           <div className="text-[#06513D] font-[Calibri] text-[18px] sm:text-[20px] leading-none tracking-tight">
//             Profile
//           </div>
//         </div>
//         {/* <div
//           style={{
//             border: "1px solid red",
//             borderRadius: "10px",
//             paddingTop: "20px",
//             boxShadow: "0px 0px 16px 0px #3BA2B91F",
//             backgroundColor:"#fff"
//           }}
//         >
//           <div className="flex">
//             <div className="w-64 font-light gap-4 leading-10 ">
//               <ul>
//                 <li
//                   onClick={() => {
//                     setOpenContactDetails(false);
//                     setOpenOrgaizationDetails(false);
//                     setOpenMyProfile(true);
//                     setopenLicenseDetails(false);
//                   }}
//                   className="cursor-pointer"
//                 >
//                   {openMyProfile ? (
//                     <div className="text-[#06513D] bg-[#E6EEEC] mr-4 ">
//                       <p className="pl-8">My Profile </p>
//                     </div>
//                   ) : (
//                     <p className="pl-8"> My Profile </p>
//                   )}
//                 </li>
//                 <li
//                   onClick={() => {
//                     setOpenContactDetails(false);
//                     setOpenOrgaizationDetails(true);
//                     setOpenMyProfile(false);
//                     setopenLicenseDetails(false);
//                   }}
//                   className="cursor-pointer"
//                 >
//                   {openOrganizationDetails ? (
//                     <div className="text-[#06513D] bg-[#E6EEEC] mr-4 ">
//                       <p className="pl-8">Organization Details</p>
//                     </div>
//                   ) : (
//                     <p className="pl-8"> Organization Details </p>
//                   )}
//                 </li>
//                 <li
//                   onClick={() => {
//                     setOpenContactDetails(true);
//                     setOpenOrgaizationDetails(false);
//                     setOpenMyProfile(false);
//                     setopenLicenseDetails(false);
//                   }}
//                   className="cursor-pointer"
//                 >
//                   {openContactdetails ? (
//                     <div className="text-[#06513D] bg-[#E6EEEC] mr-4">
//                       <p className="pl-8"> Contact Details</p>
//                     </div>
//                   ) : (
//                     <p className="pl-8"> Contact Details </p>
//                   )}
//                 </li>
//                 <li
//                   onClick={() => {
//                     setopenLicenseDetails(true);
//                     setOpenOrgaizationDetails(false);
//                     setOpenMyProfile(false);
//                     setOpenContactDetails(false);
//                   }}
//                   className="cursor-pointer"
//                 >
//                   {openLicenseDetails ? (
//                     <div className="text-[#06513D] bg-[#E6EEEC] mr-4">
//                       <p className="pl-8"> License & Access</p>
//                     </div>
//                   ) : (
//                     <p className="pl-8"> License & Access </p>
//                   )}
//                 </li>
//               </ul>
//             </div>

//             <div
//               style={{
//                 border: "1px solid #3BA2B959",
//                 borderRadius: "10px",
//                 paddingTop: "20px",
//                 boxShadow: "0px 0px 16px 0px #3BA2B91F",
//                 backgroundColor: "#fff",
//               }}
//               className="mr-4 mb-4 w-full"
//             >

//               {openLicenseDetails ? (
//                 <LicenseAccess />
//               ) : openMyProfile ? (
//                 <MyProfile />
//               ) : openOrganizationDetails ? (
//                 <OrganizationDeatils />
//               ) : (
//                 <ContactDeatils />
//               )}
//             </div>
//           </div>
//         </div> */}

//         <div
//           style={{
//             borderRadius: "10px",
//             paddingTop: "20px",
//             boxShadow: "0px 0px 16px 0px #3BA2B91F",
//             backgroundColor: "#fff",
//             border: "1px solid #3BA2B959",
//           }}
//         >
//           <div className="flex flex-col lg:flex-row">
//             <div className="w-full lg:w-64 font-light gap-4 leading-10">
//               <ul className="flex flex-row lg:flex-col overflow-x-auto lg:overflow-x-visible">
//                 <li
//                   onClick={() => {
//                     setOpenContactDetails(false);
//                     setOpenOrgaizationDetails(false);
//                     setOpenMyProfile(true);
//                     setopenLicenseDetails(false);
//                   }}
//                   className="cursor-pointer flex-shrink-0 lg:flex-shrink"
//                 >
//                   {openMyProfile ? (
//                     <div className="text-[#06513D] bg-[#E6EEEC] mr-4 lg:mr-4">
//                       <p className="pl-4 lg:pl-8 py-2 lg:py-0 whitespace-nowrap">
//                         My Profile
//                       </p>
//                     </div>
//                   ) : (
//                     <p className="pl-4 lg:pl-8 py-2 lg:py-0 whitespace-nowrap">
//                       My Profile
//                     </p>
//                   )}
//                 </li>
//                 <li
//                   onClick={() => {
//                     setOpenContactDetails(false);
//                     setOpenOrgaizationDetails(true);
//                     setOpenMyProfile(false);
//                     setopenLicenseDetails(false);
//                   }}
//                   className="cursor-pointer flex-shrink-0 lg:flex-shrink"
//                 >
//                   {openOrganizationDetails ? (
//                     <div className="text-[#06513D] bg-[#E6EEEC] mr-4 lg:mr-4">
//                       <p className="pl-4 lg:pl-8 py-2 lg:py-0 whitespace-nowrap">
//                         Organization Details
//                       </p>
//                     </div>
//                   ) : (
//                     <p className="pl-4 lg:pl-8 py-2 lg:py-0 whitespace-nowrap">
//                       Organization Details
//                     </p>
//                   )}
//                 </li>
//                 <li
//                   onClick={() => {
//                     setOpenContactDetails(true);
//                     setOpenOrgaizationDetails(false);
//                     setOpenMyProfile(false);
//                     setopenLicenseDetails(false);
//                   }}
//                   className="cursor-pointer flex-shrink-0 lg:flex-shrink"
//                 >
//                   {openContactdetails ? (
//                     <div className="text-[#06513D] bg-[#E6EEEC] mr-4 lg:mr-4">
//                       <p className="pl-4 lg:pl-8 py-2 lg:py-0 whitespace-nowrap">
//                         Contact Details
//                       </p>
//                     </div>
//                   ) : (
//                     <p className="pl-4 lg:pl-8 py-2 lg:py-0 whitespace-nowrap">
//                       Contact Details
//                     </p>
//                   )}
//                 </li>
//                 <li
//                   onClick={() => {
//                     setopenLicenseDetails(true);
//                     setOpenOrgaizationDetails(false);
//                     setOpenMyProfile(false);
//                     setOpenContactDetails(false);
//                   }}
//                   className="cursor-pointer flex-shrink-0 lg:flex-shrink"
//                 >
//                   {openLicenseDetails ? (
//                     <div className="text-[#06513D] bg-[#E6EEEC] mr-4 lg:mr-4">
//                       <p className="pl-4 lg:pl-8 py-2 lg:py-0 whitespace-nowrap">
//                         License & Access
//                       </p>
//                     </div>
//                   ) : (
//                     <p className="pl-4 lg:pl-8 py-2 lg:py-0 whitespace-nowrap">
//                       License & Access
//                     </p>
//                   )}
//                 </li>
//               </ul>
//             </div>

//             <div
//               style={{
//                 borderRadius: "10px",

//                 boxShadow: "0px 0px 16px 0px #3BA2B91F",
//                 backgroundColor: "#fff",
//               }}
//               className="mr-4 mb-4 w-full mt-4 lg:mt-0 border border-[#3BA2B959]"
//             >
//               {openLicenseDetails ? (
//                 <LicenceDetailPage />
//               ) : openMyProfile ? (
//                 <MyProfile />
//               ) : openOrganizationDetails ? (
//                 <OrganizationDeatils />
//               ) : (
//                 <ContactDeatils />
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Profile;
import React, { useEffect, useState, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import TextStyles from "../../../../../components/Elements/TextStyles/TextStyles";
import { ReactComponent as Back } from "../../../../../assets/svgs/back-button.svg";
import OrganizationDeatils from "./OrganizationDetails/OrganizationDetails";
import ContactDeatils from "./ContactDetails/ContactDetails";
import MyProfile from "./MyProfile/MyProfile";
import { useDispatch, useSelector } from "react-redux";
import { getApi } from "../../../../../api/api_instance";
import { API_URLS } from "../../../../../api/apiUrls";
import LicenseAccess from "./LicenseAccess/LicenseAccess";
import { THEME_COLORS } from "../../../../../color";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import LicenceDetailPage from "./LicenseDetailPage/LicenceDetailPage";
import PermissionForm from "../../../../Auth/PermissionForm";
import { fetchProfileData } from "../../../../../redux/ProfileSlice/profileSlice";
const Profile = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const [openMyProfile, setOpenMyProfile] = useState(true);
  const [openOrganizationDetails, setOpenOrgaizationDetails] = useState(false);
  const [openContactdetails, setOpenContactDetails] = useState(false);
  const [openLicenseDetails, setopenLicenseDetails] = useState(false);
  const [showPermission, setPermission] = useState(false);

  const { user } = useSelector((state) => state.auth);
  const isPermissionCompleted = user?.isCompleted;
  const isSubAdmin =
    user?.subAdmin?.isSubAdmin || user?.employeeData?.role === "sub_admin";

  const subAdminPermissions = useMemo(() => {
    return [
      ...(user?.subAdmin?.permissions || []),
      ...(user?.managementView?.permissions || []),
    ];
  }, [user]);

  const hasLicensePermission = useMemo(() => {
    if (!isSubAdmin) return true;
    return subAdminPermissions.some(
      (p) =>
        (p.module === "license-access" || p.module === "license") &&
        (p.access === "read" || p.access === "write"),
    );
  }, [isSubAdmin, subAdminPermissions]);

  useEffect(() => {
    if (user?._id) {
      dispatch(fetchProfileData(user._id));
    }
  }, [dispatch, user?._id]);

  // Sync state with route on component mount and route change
  useEffect(() => {
    const path = location.pathname;
    const tab = new URLSearchParams(location.search).get("tab");

    if (!isSubAdmin && tab === "myProfile") {
      setOpenMyProfile(true);
      setopenLicenseDetails(false);
      setOpenOrgaizationDetails(false);
      setOpenContactDetails(false);
    } else if (tab === "organization") {
      setOpenMyProfile(false);
      setopenLicenseDetails(false);
      setOpenOrgaizationDetails(true);
      setOpenContactDetails(false);
    } else if (!isSubAdmin && tab === "contact") {
      setOpenMyProfile(false);
      setopenLicenseDetails(false);
      setOpenOrgaizationDetails(false);
      setOpenContactDetails(true);
    } else if (
      (tab === "license" || path.includes("/license-access")) &&
      hasLicensePermission
    ) {
      setopenLicenseDetails(true);
      setOpenMyProfile(false);
      setOpenOrgaizationDetails(false);
      setOpenContactDetails(false);
    } else if (path.includes("/profile") && !path.includes("/license-access")) {
      // Default to My Profile, but Organization Details for Sub Admin
      setOpenMyProfile(!isSubAdmin);
      setopenLicenseDetails(false);
      setOpenOrgaizationDetails(isSubAdmin);
      setOpenContactDetails(false);
    } else if (isSubAdmin) {
      setOpenMyProfile(false);
      setopenLicenseDetails(false);
      setOpenOrgaizationDetails(true);
      setOpenContactDetails(false);
    }
  }, [location.pathname, location.search, isSubAdmin, hasLicensePermission]);

  // Automatically show permission form when component mounts if not completed
  useEffect(() => {
    if (!isPermissionCompleted) {
      setPermission(true);
    }
  }, [isPermissionCompleted]);

  // Handler functions that also update the route
  const handleTabChange = (tab) => {
    switch (tab) {
      case "myProfile":
        setOpenMyProfile(true);
        setOpenOrgaizationDetails(false);
        setOpenContactDetails(false);
        setopenLicenseDetails(false);
        navigate("/organization/user-management/profile?tab=myProfile");
        break;
      case "organization":
        setOpenMyProfile(false);
        setOpenOrgaizationDetails(true);
        setOpenContactDetails(false);
        setopenLicenseDetails(false);
        navigate("/organization/user-management/profile?tab=organization");
        break;
      case "contact":
        setOpenMyProfile(false);
        setOpenOrgaizationDetails(false);
        setOpenContactDetails(true);
        setopenLicenseDetails(false);
        navigate("/organization/user-management/profile?tab=contact");
        break;
      case "license":
        setOpenMyProfile(false);
        setOpenOrgaizationDetails(false);
        setOpenContactDetails(false);
        setopenLicenseDetails(true);
        navigate("/organization/user-management/license-access?tab=license");
        break;
      default:
        break;
    }
  };

  return (
    <div className="md:p-6 lg:p-0 bg-[#F5F5F5] mb-20 sm:mb-6 md:mb-6">
      {!isPermissionCompleted && showPermission && (
        <PermissionForm permissionConClose={() => setPermission(false)} />
      )}

      <div
        className={` ${
          !isPermissionCompleted ? "blur-sm opacity-20 pointer-events-none" : ""
        }`}
      >
        <div className="flex flex-wrap justify-end text-xs font-light gap-1 h-5 sm:gap-2">
          <p>Home</p>
          <span>/</span>
          <TextStyles style={{ color: "#06513D" }}>Profile</TextStyles>
        </div>

        {/* Title & Back Icon */}
        <div className="flex items-center gap-2 mb-3 sm:mb-1.5 text-lg sm:text-xl font-bold flex-wrap">
          <div className="text-[#06513D] font-[Calibri] text-[18px] sm:text-[20px] leading-none tracking-tight">
            Profile
          </div>
        </div>

        <div
          style={{
            borderRadius: "10px",
            paddingTop: "20px",
            boxShadow: "0px 0px 16px 0px #3BA2B91F",
            backgroundColor: "#fff",
            border: "1px solid #3BA2B959",
          }}
        >
          <div className="flex flex-col lg:flex-row">
            <div className="w-full lg:w-64 font-light gap-4 leading-10">
              <ul className="flex flex-row lg:flex-col overflow-x-auto lg:overflow-x-visible">
                {!isSubAdmin && (
                  <li
                    onClick={() => handleTabChange("myProfile")}
                    className="cursor-pointer flex-shrink-0 lg:flex-shrink"
                  >
                    {openMyProfile ? (
                      <div className="text-[#06513D] bg-[#E6EEEC] mr-4 lg:mr-4">
                        <p className="pl-4 lg:pl-8 py-2 lg:py-0 whitespace-nowrap">
                          My Profile
                        </p>
                      </div>
                    ) : (
                      <p className="pl-4 lg:pl-8 py-2 lg:py-0 whitespace-nowrap">
                        My Profile
                      </p>
                    )}
                  </li>
                )}
                <li
                  onClick={() => handleTabChange("organization")}
                  className="cursor-pointer flex-shrink-0 lg:flex-shrink"
                >
                  {openOrganizationDetails ? (
                    <div className="text-[#06513D] bg-[#E6EEEC] mr-4 lg:mr-4">
                      <p className="pl-4 lg:pl-8 py-2 lg:py-0 whitespace-nowrap">
                        Organization Details
                      </p>
                    </div>
                  ) : (
                    <p className="pl-4 lg:pl-8 py-2 lg:py-0 whitespace-nowrap">
                      Organization Details
                    </p>
                  )}
                </li>
                {/* {!isSubAdmin && (
                  <>
                    <li
                      onClick={() => handleTabChange("contact")}
                      className="cursor-pointer flex-shrink-0 lg:flex-shrink"
                    >
                      {openContactdetails ? (
                        <div className="text-[#06513D] bg-[#E6EEEC] mr-4 lg:mr-4">
                          <p className="pl-4 lg:pl-8 py-2 lg:py-0 whitespace-nowrap">
                            Contact Details
                          </p>
                        </div>
                      ) : (
                        <p className="pl-4 lg:pl-8 py-2 lg:py-0 whitespace-nowrap">
                          Contact Details
                        </p>
                      )}
                    </li>
                  </>
                )} */}
                {(!isSubAdmin || hasLicensePermission) && (
                  <li
                    onClick={() => handleTabChange("license")}
                    className="cursor-pointer flex-shrink-0 lg:flex-shrink"
                  >
                    {openLicenseDetails ? (
                      <div className="text-[#06513D] bg-[#E6EEEC] mr-4 lg:mr-4">
                        <p className="pl-4 lg:pl-8 py-2 lg:py-0 whitespace-nowrap">
                          License & Access
                        </p>
                      </div>
                    ) : (
                      <p className="pl-4 lg:pl-8 py-2 lg:py-0 whitespace-nowrap">
                        License & Access
                      </p>
                    )}
                  </li>
                )}
              </ul>
            </div>

            <div
              style={{
                borderRadius: "10px",
                boxShadow: "0px 0px 16px 0px #3BA2B91F",
                backgroundColor: "#fff",
              }}
              className="mr-4 mb-4 w-full mt-4 lg:mt-0 border border-[#3BA2B959]"
            >
              {openLicenseDetails ? (
                <LicenceDetailPage />
              ) : openMyProfile ? (
                <MyProfile />
              ) : openOrganizationDetails ? (
                <OrganizationDeatils />
              ) : (
                <ContactDeatils />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
